/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

:host {
  display: block;
}
:host .label {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  display: flex;
  align-items: center;
  cursor: default;
}
:host .outer-wrapper {
  display: inline-block;
  background-color: var(--gray-01);
  border: 1px solid transparent;
  border-radius: var(--border-radius-md);
  transition-property: background-color;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
  transition-property: background-color;
  transition-duration: 0.1s;
  transition-timing-function: ease;
}
:host .value-container {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  display: flex;
  align-items: center;
  cursor: default;
  align-items: center;
  justify-content: center;
  width: 36px;
  display: inline-flex;
  margin-bottom: 0;
  background-color: transparent;
  position: relative;
  top: -2px;
}
:host .button {
  display: inline-flex;
  width: var(--spacing-comp-05);
  height: 20px;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: var(--color-primary-active);
  color: var(--color-on-primary);
  cursor: pointer;
  font-weight: var(--font-weight-regular);
  border: 1px solid transparent;
  box-shadow: 0px 0px 0px 1px var(--color-primary-active);
}
:host .button:focus {
  outline: none;
  border-color: var(--color-on-primary);
  box-shadow: 0px 0px 0px 1px var(--color-primary-enabled);
}
:host .button--minus {
  border-top-left-radius: var(--border-radius-md);
  border-bottom-left-radius: var(--border-radius-md);
}
:host .button--plus {
  border-top-right-radius: var(--border-radius-md);
  border-bottom-right-radius: var(--border-radius-md);
}
:host .button:hover {
  background-color: var(--color-primary-hover);
  box-shadow: 0px 0px 0px 1px var(--color-primary-hover);
}

:host(.rtl) .button--minus {
  border-top-right-radius: var(--border-radius-md);
  border-bottom-right-radius: var(--border-radius-md);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:host(.rtl) .button--plus {
  border-top-left-radius: var(--border-radius-md);
  border-bottom-left-radius: var(--border-radius-md);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

:host(:focus) {
  outline: none;
}
:host(:focus) .outer-wrapper {
  border-color: var(--color-on-primary);
  box-shadow: 0px 0px 0px 1px var(--color-primary-enabled);
}

:host([disabled]) .outer-wrapper,
:host([disabled]) .button {
  cursor: not-allowed;
}
:host([disabled]) .button {
  background-color: var(--color-primary-disabled);
}

:host .button[disabled] {
  background-color: var(--color-primary-disabled);
  box-shadow: 0px 0px 0px 1px var(--color-primary-disabled);
}

:host([label-position=start]) {
  display: flex;
  align-items: center;
}
:host([label-position=start]) .label {
  margin-bottom: 0;
  margin-inline-end: var(--spacing-comp-01);
}